export function buildNoteForm(action: string, botsProspectId: string, notes: string) {
  // create outer div
  const div = document.createElement('div');
  div.className = `notes-form notes-${botsProspectId}`;

  // create form element
  const form = document.createElement('form');
  form.className = 'simple_form write-note-form form-horizontal customize-message-form';
  form.id = `edit_bots_prospect_${botsProspectId}`;
  form.action = action;
  form.acceptCharset = 'UTF-8';
  form.setAttribute('data-remote', 'true');
  form.method = 'post';
  form.setAttribute('data-hs-cf-bound', 'true');

  // add hidden input for _method
  const methodInput = document.createElement('input');
  methodInput.type = 'hidden';
  methodInput.name = '_method';
  methodInput.value = 'patch';
  methodInput.autocomplete = 'off';
  form.appendChild(methodInput);

  // add hidden input for redirect_to
  const redirectInput = document.createElement('input');
  redirectInput.type = 'hidden';
  redirectInput.name = 'redirect_to';
  redirectInput.id = 'redirect_to';
  redirectInput.autocomplete = 'off';
  form.appendChild(redirectInput);

  // create form-group div for textarea
  const formGroup = document.createElement('div');
  formGroup.className = 'form-group text optional bots_prospect_notes';

  // add textarea
  const textarea = document.createElement('textarea');
  textarea.className = 'form-control text optional summernote';
  textarea.name = 'bots_prospect[notes]';
  textarea.id = 'bots_prospect_notes';
  textarea.value = notes;

  // add submit button
  const submitButton = document.createElement('input');
  submitButton.type = 'submit';
  submitButton.name = 'commit';
  submitButton.value = 'Save';
  submitButton.className = 'btn btn-primary right-aligned';
  submitButton.setAttribute('data-disable-with', 'Save');

  // build form
  formGroup.appendChild(textarea);
  form.appendChild(formGroup);
  form.appendChild(submitButton);
  div.appendChild(form);

  return div;
}
